import {useLocation, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {resetPasswordSchema2} from "../../../utils/resetPasswordSchema";
import React, {useEffect, useState} from "react";
import {useResetPasswordMutation} from "../../../api/resetPasswordAPI";
import {useAuth} from "../AuthContext";
import { toast } from "../../../utils/toast";


const ResetPasswordPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const result = location.state?.result;
    const [isLoading, setIsLoading] = useState(false);
    const resetPasswordMutation = useResetPasswordMutation();
    // 인증번호 요청 결과 메시지 상태 관리
    const [verificationMessage, setVerificationMessage] = useState("");

    // 인증되지 않은경우 잘못된 접근으로 간주
    const { isPasswordResetAllowed, disallowPasswordReset } = useAuth();

    useEffect(() => {
        if (!isPasswordResetAllowed) {
            navigate('/login', { state: { message: '잘못된 접근입니다.' } });
        }
    }, [isPasswordResetAllowed, navigate]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: zodResolver(resetPasswordSchema2),
        mode: 'onChange',
    });

    const password = watch('password');
    const passwordConfirm = watch('passwordConfirm');

    const onSubmit = async (formData) => {
        setIsLoading(true);

        const submitData = {
            loginId : result,
            newPassword : formData.password,
            newPasswordConfirm : formData.passwordConfirm,
        };

        console.log("비밀번호 변경 요청:", submitData);

        if (submitData.password !== submitData.passwordConfirm){
            // toast("비밀번호와 재확인 비밀번호가 일치하지 않습니다.");
            setVerificationMessage("비밀번호와 재확인 비밀번호가 일치하지 않습니다.");
            setIsLoading(false);
            return;
        }

        try{
            console.log("비밀번호 변경 요청:", submitData);
            // 비밀번호 변경 요청
            let result = await resetPasswordMutation.mutateAsync(submitData);
            if (result["message"] === "비밀번호 변경 성공") {
                toast("비밀번호 변경 성공");
                navigate("/login");
                result = null;
                disallowPasswordReset();    // 변경에 성공하면 뒤로가기로 다시 접속할 수 없게 변경.
            }

        } catch (error) {
            console.error("비밀번호 변경 실패:", error);
            setVerificationMessage("비밀번호 변경에 실패했습니다.");
            throw error;
        } finally {
            // 비밀번호 변경 요청 완료 시 로딩 상태 해제
            setIsLoading(false);
        }

    }

    // 잘못된 접근일 경우
    if (!result) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
                <div className="w-full max-w-md space-y-8">
                    <h2 className="text-2xl font-bold mb-4 text-center">잘못된 접근입니다.</h2>
                    <button
                        onClick={() => navigate('/find-pw')}
                        className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mt-6 disabled:opacity-50"
                    >
                        비밀번호 찾기로 돌아가기
                    </button>
                </div>
            </div>
        );
    }
    else {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
                <div className="w-full max-w-md space-y-8">
                    <h2 className="text-2xl font-bold mb-4 text-center">비밀번호 변경</h2>
                    <form className="mt-8 space-y-4"
                          onSubmit={handleSubmit(onSubmit)}
                    >
                        <input
                            {...register("password")}
                            type="password"
                            placeholder="비밀번호를 입력하세요"
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.password && (
                            <p className="mt-1 text-sm text-red-500">
                                {errors.password.message}
                            </p>
                        )}
                        <div className="flex items-center space-x-2 mb-4">
                            <input
                                {...register("passwordConfirm")}
                                type="password"
                                placeholder="비밀번호 재확인"
                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            {errors.passwordConfirm && (
                                <p className="mt-1 text-sm text-red-500">
                                    {errors.passwordConfirm.message}
                                </p>
                            )}
                        </div>
                        {verificationMessage && (
                            <p
                                className={`mt-2 text-sm ${
                                    verificationMessage.includes("발송되었습니다.")
                                        ? "text-green-500"
                                        : "text-red-500"
                                }`}
                            >
                                {verificationMessage}
                            </p>
                        )}

                        <button
                            type="submit"
                            className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mt-6 disabled:opacity-50"
                            disabled={isLoading || !password || !passwordConfirm}
                        >
                            {isLoading ? "처리 중..." : "비밀번호 변경"}
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}

export default ResetPasswordPage;